export default __webpack_public_path__ + "static/media/Group 3176@2x.1eb18120.png";